module.exports = __webpack_public_path__ + "img/4e36048c49861214473f95c21f91afe6.svg";